// extracted by mini-css-extract-plugin
module.exports = {"grid":"client-grid-module--grid--1GNCU"};